import axios from 'axios';
import setInterceptors from '../interceptors';
export default class BaseMicroservices {
    constructor() {
        this.axios = axios.create({
            baseURL: process.env.REACT_APP_SUMADI_EXAMS_MICROSERVICES_URL,
        });
        this.axios = setInterceptors(this.axios);
    }
}
